const crcTable = new Uint32Array(256);

for (let i = 0; i < crcTable.length; i += 1) {
  let value = i;
  for (let bit = 0; bit < 8; bit += 1) {
    value = value & 1 ? 0xedb88320 ^ (value >>> 1) : value >>> 1;
  }
  crcTable[i] = value >>> 0;
}

function crc32(buffer) {
  let crc = 0xffffffff;
  for (const byte of buffer) {
    crc = crcTable[(crc ^ byte) & 0xff] ^ (crc >>> 8);
  }
  return (crc ^ 0xffffffff) >>> 0;
}

function toDosDateTime(date) {
  const year = Math.max(1980, date.getFullYear());
  const dosTime =
    (date.getHours() << 11) |
    (date.getMinutes() << 5) |
    Math.floor(date.getSeconds() / 2);
  const dosDate =
    ((year - 1980) << 9) | ((date.getMonth() + 1) << 5) | date.getDate();

  return { dosDate, dosTime };
}

function writeLocalFileHeader({ fileName, data, crc, dosDate, dosTime }) {
  const fileNameBuffer = Buffer.from(fileName);
  const header = Buffer.alloc(30);
  header.writeUInt32LE(0x04034b50, 0);
  header.writeUInt16LE(20, 4);
  header.writeUInt16LE(0, 6);
  header.writeUInt16LE(0, 8);
  header.writeUInt16LE(dosTime, 10);
  header.writeUInt16LE(dosDate, 12);
  header.writeUInt32LE(crc, 14);
  header.writeUInt32LE(data.byteLength, 18);
  header.writeUInt32LE(data.byteLength, 22);
  header.writeUInt16LE(fileNameBuffer.byteLength, 26);
  header.writeUInt16LE(0, 28);

  return Buffer.concat([header, fileNameBuffer]);
}

function writeCentralDirectoryHeader({
  fileName,
  data,
  crc,
  dosDate,
  dosTime,
  offset,
}) {
  const fileNameBuffer = Buffer.from(fileName);
  const header = Buffer.alloc(46);
  header.writeUInt32LE(0x02014b50, 0);
  header.writeUInt16LE(20, 4);
  header.writeUInt16LE(20, 6);
  header.writeUInt16LE(0, 8);
  header.writeUInt16LE(0, 10);
  header.writeUInt16LE(dosTime, 12);
  header.writeUInt16LE(dosDate, 14);
  header.writeUInt32LE(crc, 16);
  header.writeUInt32LE(data.byteLength, 20);
  header.writeUInt32LE(data.byteLength, 24);
  header.writeUInt16LE(fileNameBuffer.byteLength, 28);
  header.writeUInt16LE(0, 30);
  header.writeUInt16LE(0, 32);
  header.writeUInt16LE(0, 34);
  header.writeUInt16LE(0, 36);
  header.writeUInt32LE(0, 38);
  header.writeUInt32LE(offset, 42);

  return Buffer.concat([header, fileNameBuffer]);
}

function writeEndOfCentralDirectory({ entryCount, centralSize, centralOffset }) {
  const header = Buffer.alloc(22);
  header.writeUInt32LE(0x06054b50, 0);
  header.writeUInt16LE(0, 4);
  header.writeUInt16LE(0, 6);
  header.writeUInt16LE(entryCount, 8);
  header.writeUInt16LE(entryCount, 10);
  header.writeUInt32LE(centralSize, 12);
  header.writeUInt32LE(centralOffset, 16);
  header.writeUInt16LE(0, 20);

  return header;
}

export function createStoreZip(files, { modifiedAt = new Date() } = {}) {
  const { dosDate, dosTime } = toDosDateTime(modifiedAt);
  const localParts = [];
  const centralParts = [];
  let offset = 0;

  for (const file of files) {
    const data = Buffer.isBuffer(file.data)
      ? file.data
      : Buffer.from(file.data);
    const checksum = crc32(data);
    const localHeader = writeLocalFileHeader({
      fileName: file.name,
      data,
      crc: checksum,
      dosDate,
      dosTime,
    });
    const centralHeader = writeCentralDirectoryHeader({
      fileName: file.name,
      data,
      crc: checksum,
      dosDate,
      dosTime,
      offset,
    });

    localParts.push(localHeader, data);
    centralParts.push(centralHeader);
    offset += localHeader.byteLength + data.byteLength;
  }

  const centralOffset = offset;
  const centralDirectory = Buffer.concat(centralParts);
  const end = writeEndOfCentralDirectory({
    entryCount: files.length,
    centralSize: centralDirectory.byteLength,
    centralOffset,
  });

  return Buffer.concat([...localParts, centralDirectory, end]);
}
